import React, { forwardRef, memo } from 'react';
import { Image } from 'expo-image';
import { communities, type CommunityCode } from '@/constants/communities';

export interface ICommunityHeroBannerProps {
  community: CommunityCode;
  contentFit?: 'cover' | 'contain' | 'fill' | 'scale-down' | 'none';
  className?: string;
}

const CommunityHeroBannerBase = forwardRef<any, ICommunityHeroBannerProps>(
  ({ community, contentFit = 'cover', className }, ref) => {
    const source = communities[community]?.heroBanner as any;
    if (!source) return null;

    return (
      <Image
        ref={ref}
        source={source}
        className={className}
        contentFit={contentFit}
        enforceEarlyResizing
      />
    );
  }
);

export const CommunityHeroBanner = memo(CommunityHeroBannerBase);

export default CommunityHeroBanner;


